module.exports = __webpack_public_path__ + "img/SquidNeuro-584x584.7e73f3ce.webp";